import { Typography } from '@mui/material'
import FormAddLocation from '../../components/FormAddLocation/FormAddLocation'
import * as S from './AddLocations.styles'
import DownloadTemplate from 'src/features/base/components/DownloadTemplate'

const AddLocations = () => (
  <S.Wrapper>
    <Typography variant='h5' fontWeight='bold'>Cadastrar Localizações</Typography>
    <DownloadTemplate
      href='/add_location_template.csv'
    />
    <FormAddLocation />
  </S.Wrapper>
)

export default AddLocations
